import { cn } from "@/lib/utils"

interface MainContentProps {
  children: React.ReactNode
  className?: string
  containerClassName?: string
}

/**
 * MainContent component - container principal para o conteúdo das páginas.
 * Já inclui os estilos padrão de layout (flex, z-index, min-height) e o container interno.
 */
export function MainContent({ children, className, containerClassName }: MainContentProps) {
  return (
    <main
      className={cn(
        "flex-1 flex flex-col relative z-10 min-h-[calc(98vh-4rem)]",
        className
      )}
    >
      <div className={cn("flex flex-col page-container section-gap-lg pb-20", containerClassName)}>
        {children}
      </div>
    </main>
  )
}
